import convert from 'pcm-convert';
const BUFFER_SIZE = 2048;

export function intBuffer2dToAudio(intbuffer) {
    let intbuffer2 = convert(flatten2dBuffers(intbuffer), 'float32', 'int16');
    let blob = intBufferToWavBlob(intbuffer2);
    const audioUrl = URL.createObjectURL(blob);
    const audio = new Audio(audioUrl);

    return audio;
}

// export function intBuffer2dToAudioURL(intbuffer) {
//     let intbuffer2 = convert(flatten2dBuffers(intbuffer), 'float32', 'int16');
//     let blob = intBufferToWavBlob(intbuffer2);
//     const audioUrl = URL.createObjectURL(blob);

//     return audioUrl;
// }

export function intBufferToWavBlob(intBuffer, sampleRate) {
    var header = buildWaveHeader({
        numFrames: intBuffer.length,
        numChannels: 1,
        sampleRate: sampleRate,
    });
    var blob = new Blob([header, intBuffer]);
    // saveData(blob, 'blob.wav');

    return blob;
}

export function buildWaveHeader(opts) {
    var numFrames = opts.numFrames;
    var numChannels = opts.numChannels || 2;
    console.log('the sample rate is **********', opts.sampleRate);

    var sampleRate = opts.sampleRate || 44100;
    var bytesPerSample = opts.bytesPerSample || 2;
    var blockAlign = numChannels * bytesPerSample;
    var byteRate = sampleRate * blockAlign;
    var dataSize = numFrames * blockAlign;

    var buffer = new ArrayBuffer(44);
    var dv = new DataView(buffer);

    var p = 0;

    function writeString(s) {
        for (var i = 0; i < s.length; i++) {
            dv.setUint8(p + i, s.charCodeAt(i));
        }
        p += s.length;
    }

    function writeUint32(d) {
        dv.setUint32(p, d, true);
        p += 4;
    }

    function writeUint16(d) {
        dv.setUint16(p, d, true);
        p += 2;
    }

    writeString('RIFF'); // ChunkID
    writeUint32(dataSize + 36); // ChunkSize
    writeString('WAVE'); // Format
    writeString('fmt '); // Subchunk1ID
    writeUint32(16); // Subchunk1Size
    writeUint16(1); // AudioFormat
    writeUint16(numChannels); // NumChannels
    writeUint32(sampleRate); // SampleRate
    writeUint32(byteRate); // ByteRate
    writeUint16(blockAlign); // BlockAlign
    writeUint16(bytesPerSample * 8); // BitsPerSample
    writeString('data'); // Subchunk2ID
    writeUint32(dataSize); // Subchunk2Size

    return buffer;
}

// Save response to file
// e.g. saveData(blob, 'coolvoice.wav');
export function saveData(blob, fileName) {
    var a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    var url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
}

export function flatten2dBuffers(buffer) {
    var l = buffer.length; // Buffer length
    var newBuff = new Float32Array(l * BUFFER_SIZE);

    let newIndex = 0;
    for (let i = 0; i < l; i++) {
        for (let j = 0; j < buffer[i].length; j++) {
            let curr = buffer[i][j];
            newBuff[newIndex] = curr;
            newIndex++;
        }
    }
    return newBuff;
}

// Recursively plays an array of audioUrls
export function playAudio(
    audioUrls,
    arrayLength,
    startIndex,
    onFinishedPlaying
) {
    if (startIndex === arrayLength) {
        onFinishedPlaying();
        return;
    } else {
        const audio = new Audio(audioUrls[startIndex]);
        audio.play();
        audio.onended = function() {
            playAudio(
                audioUrls,
                arrayLength,
                startIndex + 1,
                onFinishedPlaying
            );
        };
    }
}

// function playSound(
//     file,
//     speed = 1,
//     pitchShift = 1,
//     loop = false,
//     autoplay = true
// ) {
//     /*
//     Use the play() method to start the audio. if pitchShift is true
//     use the stop() method to stop the audio and destroy the object.
//     If pitchShift is false use the pause() method to pause and set
//     the attribute currentTime to 0 to reset the time.
//     */
//     if (pitchShift) {
//         /*
//         After weeks of searching, I have finally found a way to pitch shift audio.
//         Thank you Mozilla.
//         2018/03/31:
//             https://developer.mozilla.org/en-US/docs/Web/API/AudioBufferSourceNode/playbackRate
//             https://github.com/mdn/webaudio-examples/tree/master/decode-audio-data
//             https://www.w3schools.com/jsref/prop_audio_loop.asp
//         Original comments:
//             use XHR to load an audio track, and
//             decodeAudioData to decode it and stick it in a buffer.
//             Then we put the buffer into the source
//         */
//         let audioCtx = new (window.AudioContext || window.webkitAudioContext)();
//         let source = audioCtx.createBufferSource();
//         let request = new XMLHttpRequest();

//         request.open('GET', file, true);

//         request.responseType = 'arraybuffer';

//         request.onload = function() {
//             var audioData = request.response;

//             audioCtx.decodeAudioData(
//                 audioData,
//                 function(buffer) {
//                     let myBuffer = buffer;
//                     let songLength = buffer.duration;
//                     source.buffer = myBuffer;
//                     source.playbackRate.value = speed;
//                     source.connect(audioCtx.destination);
//                     source.loop = loop;
//                 },

//                 function(e) {
//                     console.log('Error with decoding audio data' + e.error);
//                 }
//             );
//         };

//         request.send();
//         source.play = source.start;
//     } else {
//         let source = new Audio(file);
//         source.playbackRate = speed;
//         source.loop = loop;
//     }
//     if (autoplay) {
//         // source.play();
//     }
//     // return source;
// }
